import React, { useState } from 'react';
import BillingDateManager from './BillingDateManager';
import Modal from './Modal';

interface BillingDateManagerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: (message: string) => void;
  onError?: (error: string) => void;
}

const BillingDateManagerModal: React.FC<BillingDateManagerModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
  onError
}) => {
  const [notifications, setNotifications] = useState<{
    success: string[];
    errors: string[];
  }>({ success: [], errors: [] });

  const handleSuccess = (message: string) => {
    setNotifications(prev => ({
      ...prev,
      success: [...prev.success, message]
    }));
    onSuccess?.(message);
  };

  const handleError = (error: string) => {
    setNotifications(prev => ({
      ...prev,
      errors: [...prev.errors, error]
    }));
    onError?.(error);
  };

  const clearNotifications = () => {
    setNotifications({ success: [], errors: [] });
  };

  const handleClose = () => {
    clearNotifications();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Billing Date Manager"
      size="xl"
    >
      <div className="billing-date-manager-modal">
        {/* Notifications */}
        {notifications.success.length > 0 && (
          <div className="alert alert-success alert-dismissible fade show" role="alert">
            <ul className="mb-0">
              {notifications.success.map((message, index) => (
                <li key={index}>{message}</li>
              ))}
            </ul>
            <button
              type="button"
              className="btn-close"
              onClick={() => setNotifications(prev => ({ ...prev, success: [] }))}
            ></button>
          </div>
        )}

        {notifications.errors.length > 0 && (
          <div className="alert alert-danger alert-dismissible fade show" role="alert">
            <ul className="mb-0">
              {notifications.errors.map((error, index) => (
                <li key={index}>{error}</li>
              ))}
            </ul>
            <button
              type="button"
              className="btn-close"
              onClick={() => setNotifications(prev => ({ ...prev, errors: [] }))}
            ></button>
          </div>
        )}

        {/* Main Component */}
        <BillingDateManager
          onClose={handleClose}
          onSuccess={handleSuccess}
          onError={handleError}
        />
      </div>
    </Modal>
  );
};

export default BillingDateManagerModal;